<template>
  <div class="zb-main">
    <img class="map-pic" src="@/assets/images/schj/zb.png" alt="" />

    <img
      src="@/assets/images/schj/tolx.png"
      @click="toLx"
      alt=""
      class="btm-lx"
    />
    <img
      src="@/assets/images/schj/tocg.png"
      @click="tocg"
      alt=""
      class="btm-lx2"
    />
    <img
      src="@/assets/images/schj/cssk.png"
      @click="tosk"
      alt=""
      class="btm-lx3"
    />
    <img
      src="@/assets/images/schj/lsys.jpg"
      @click="toys"
      alt=""
      class="btm-lx4"
    />

    <el-dialog
      ref="dialog"
      :visible.sync="showdialog"
      :append-to-body="true"
      width="500px"
      top="0"
      custom-class="ifr-dialog"
    >
      <img src="@/assets/images/schj/ys-detail.jpg" style="width:100%" alt="" />
    </el-dialog>
  </div>
</template>

<script>
// 占比 pic 版本
export default {
  data() {
    return {
      showdialog: false
    };
  },
  methods: {
    toys() {
      // TODO: 弹窗图片
      this.showdialog = true;
    },
    toLx() {
      this.$store.dispatch("schj/setCode", "lx");
    },
    tocg() {
      this.$store.dispatch("schj/setCode", "cg");
    },
    tosk() {
      this.$router.push({
        path: "/video",
        query: {
          index: 2
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.zb-main
    width 100%
    height 100%
    z-index 1
    position relative
    .map-pic
        margin-left 27%
        margin-top 12vh
    .btm-lx
        position absolute
        left 28%
        bottom 3vh
        cursor pointer
    .btm-lx2
        position absolute
        left calc(28% + 0.5rem)
        bottom 3vh
        cursor pointer
    .btm-lx3
        position absolute
        left calc(28% + 1rem)
        bottom 3vh
        cursor pointer
    .btm-lx4
        position absolute
        left calc(28% + 1.5rem)
        bottom 3vh
        cursor pointer
</style>
